import {ReactNode} from 'react';
import {t} from '../../../common/getTranslations';
import {ErrorArea} from '../../../design-system/organisms/ErrorArea/ErrorArea';

/**
 * refundAmount 가 0 이상인 경우에만 children 을 렌더링하는 체커
 */
export function RefundableAmountExistsCheckerHeadless({
  isMobile,
  refundableAmount,
  children,
}: {
  isMobile: boolean;
  refundableAmount: number;
  children?: ReactNode;
}) {
  if (!refundableAmount || refundableAmount <= 0) {
    return (
      <ErrorArea isMobile={isMobile}>
        <ErrorArea.Title>
          {t('more_customer_cash_refund_no_result')}
        </ErrorArea.Title>
        <ErrorArea.MainText>
          {t('more_customer_cash_refund_no_result_detail')}
        </ErrorArea.MainText>
      </ErrorArea>
    );
  }
  if (!children) {
    return null;
  }
  return <>{children}</>;
}
